"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_core_1 = require("moralis/common-core");
var api_utils_1 = require("@moralisweb3/api-utils");
var common_auth_utils_1 = require("@moralisweb3/common-auth-utils");
var credentials_1 = __importDefault(require("next-auth/providers/credentials"));
var moralis_1 = __importDefault(require("moralis"));
var MoralisNextAuthProvider = function () {
    /**
     * Configuring default CredentialsProvider from 'next-auth'
     * with required steps and data for verifying signed message
     */
    return (0, credentials_1.default)({
        name: 'MoralisAuth',
        id: 'moralis-auth',
        /**
         * Credentials is required data for authentication
         * Received from Moralis.Auth.requestMessage()
         * Provided via signin()
         */
        credentials: {
            message: {
                label: 'Message',
                type: 'text',
                placeholder: '0x0',
            },
            signature: {
                label: 'Signature',
                type: 'text',
                placeholder: '0x0',
            },
            network: {
                label: 'Network',
                type: 'text',
                placeholder: 'Evm',
            },
        },
        authorize: function (credentials) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, message, signature, _b, network, nextAuthUrl, baseUrl, user, _c, e_1, logger;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 7, , 8]);
                            _a = credentials, message = _a.message, signature = _a.signature, _b = _a.network, network = _b === void 0 ? 'Evm' : _b;
                            nextAuthUrl = process.env.NEXTAUTH_URL;
                            if (!nextAuthUrl) {
                                throw new Error('NEXTAUTH_URL missing');
                            }
                            baseUrl = moralis_1.default.Auth.baseUrl;
                            user = void 0;
                            _c = network;
                            switch (_c) {
                                case 'Evm': return [3 /*break*/, 1];
                                case 'Solana': return [3 /*break*/, 3];
                            }
                            return [3 /*break*/, 5];
                        case 1: return [4 /*yield*/, new api_utils_1.OperationResolver(common_auth_utils_1.verifyChallengeEvmOperation, baseUrl, moralis_1.default.Core).fetch({
                                message: message,
                                signature: signature,
                            })];
                        case 2:
                            user = (_d.sent()).raw;
                            return [3 /*break*/, 6];
                        case 3: return [4 /*yield*/, new api_utils_1.OperationResolver(common_auth_utils_1.verifyChallengeSolanaOperation, baseUrl, moralis_1.default.Core).fetch({
                                message: message,
                                signature: signature,
                            })];
                        case 4:
                            user = (_d.sent()).raw;
                            return [3 /*break*/, 6];
                        case 5: throw new Error("The ".concat(network, " networkType is not supported for authentication"));
                        case 6:
                            if (user.uri !== nextAuthUrl) {
                                return [2 /*return*/, null];
                            }
                            /**
                             * Defining and returning user profile
                             */
                            return [2 /*return*/, user];
                        case 7:
                            e_1 = _d.sent();
                            logger = new common_core_1.LoggerController('Next', moralis_1.default.Core.config);
                            logger.error(e_1);
                            return [2 /*return*/, null];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
    });
};
exports.default = MoralisNextAuthProvider;
//# sourceMappingURL=MoralisNextAuthProvider.js.map